import { jsx as _jsx } from "react/jsx-runtime";
import { NotesPanel } from '@/shared/components/NotesPanel';
import { useStudentNotes, useAddStudentNote, useDeleteStudentNote } from '../hooks/useStudentTabs';
/**
 * Tab "Anotaciones" de la ficha: historial fechado de anotaciones privadas
 * del director (student_notes). Solo-director end-to-end: la ruta de la ficha
 * ya es de director y el backend exige @Roles(DIRECTOR) + RLS. La UI vive en
 * el NotesPanel compartido (también lo usan los posibles alumnos).
 */
export function TabAnotaciones({ studentId }) {
    const { data: notes = [], isLoading, isError } = useStudentNotes(studentId);
    const addNote = useAddStudentNote(studentId);
    const deleteNote = useDeleteStudentNote(studentId);
    return (_jsx(NotesPanel, { notes: notes, isLoading: isLoading, isError: isError, addPending: addNote.isPending, addFailed: addNote.isError, deletePending: deleteNote.isPending, onAdd: (note, opts) => addNote.mutate(note, opts), onDelete: (noteId, opts) => deleteNote.mutate(noteId, opts), placeholder: "Escribe aqu\u00ED una anotaci\u00F3n de inter\u00E9s sobre el alumno\u2026" }));
}
//# sourceMappingURL=TabAnotaciones.js.map